export default __webpack_public_path__ + "static/media/Animals2_10.7e41adaf.png";